import { type ReactNode } from "react";
import styles from "./Avatar.module.css";
// @ts-expect-error pure js
import { classnames } from "../../utils";
import { Avatar as BaseAvatar } from "@base-ui/react/avatar";

export type AvatarSize = "sm" | "md" | "lg";
export type AvatarVariant =
  | "yellow"
  | "blue"
  | "green"
  | "orange"
  | "purple"
  | "teal"
  | "brown"
  | "gray"
  | "red";

interface AvatarProps {
  initials?: string;
  icon?: ReactNode;
  size?: AvatarSize;
  variant?: AvatarVariant;
  className?: string;
  style?: object;
}

function hashName(name: string): number {
  let hash = 5;
  if (name.length === 0) return hash;
  for (let i = 0; i < name.length; i++) {
    const ch = name.charCodeAt(i);
    hash = (hash << 5) - hash + ch;
    hash = hash & hash;
  }
  return Math.abs(hash) % 9;
}

const variantFromHash: AvatarVariant[] = [
  "blue",
  "red",
  "green",
  "orange",
  "purple",
  "teal",
  "brown",
  "gray",
  "yellow",
];

export default function Avatar({
  initials,
  icon,
  size = "md",
  variant,
  className,
}: AvatarProps) {
  const computedVariant =
    variant ?? (initials ? variantFromHash[hashName(initials)] : "yellow");

  return (
    <BaseAvatar.Root
      className={classnames(
        styles.avatar,
        styles[size],
        styles[computedVariant],
        className,
      )}
    >
      {icon ?? initials}
    </BaseAvatar.Root>
  );
}
